import { useState } from 'react'

import { ReportType, getEmployessEndOfWeekAndEndOfMonthReport } from 'core'
import { now } from 'core/application/commons/dateUtils'

import { Button, Card, Col, Row, SimpleDatepicker } from 'common/components'
import { downloadCSV } from 'common/downloadFile'
import { useQueryRequestV2 } from 'common/hooks'

interface EmployeesReportSectionProps {
  name: string
  reportType: ReportType
}

const EmployeesReportSection = ({ name, reportType }: EmployeesReportSectionProps) => {
  const [loading, setLoading] = useState<boolean>(false)
  const [date, setDate] = useState<string>(null)
  const { isLoading, sendQuery } = useQueryRequestV2()

  const handleDateChange = (_, dateString: string) => {
    setDate(dateString)
  }

  const handleDownloadLatest = async () => {
    setLoading(true)
    const result = await sendQuery(() =>
      getEmployessEndOfWeekAndEndOfMonthReport({ reportType: ReportType.Daily, reportDate: null }),
    )
    if (result) {
      downloadCSV(result.toString(), `${date}_Employees_${ReportType[ReportType.Daily]}_report.csv`)
    }

    setLoading(false)
  }
  const handleSubmit = async () => {
    setLoading(true)
    const result = await sendQuery(() => getEmployessEndOfWeekAndEndOfMonthReport({ reportType, reportDate: date }))
    if (result) {
      downloadCSV(result.toString(), `${date}_Employees_${ReportType[reportType]}_report.csv`)
    }

    setLoading(false)
  }
  return (
    <Card title={name}>
      <Row className="mt-16">
        <Col span={8}>
          {reportType === ReportType.Weekly ? (
            <SimpleDatepicker
              placeholder="Select Week"
              className="w-100"
              format={'MM/DD/YYYY'}
              picker="week"
              onChange={handleDateChange}
              allowClear={false}
              disabledDate={(d) => !d || d.isAfter(now()) || d.day() !== 1}
            />
          ) : (
            <SimpleDatepicker
              placeholder="Select Month"
              className="w-100"
              format={'YYYY/MM'}
              picker="month"
              onChange={handleDateChange}
              allowClear={false}
              disabledDate={(d) => d.isAfter(now())}
            />
          )}
        </Col>
      </Row>
      <Row className="mt-16">
        <Col span={8}>
          <Button type="primary" loading={loading} onClick={handleSubmit}>
            Download Report
          </Button>
        </Col>
        <Col span={8}>
          <Row className="mt-16 center">
            <Col span={8}>
              <Button type="primary" loading={loading} onClick={handleDownloadLatest}>
                Download Latest Report
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  )
}

export default EmployeesReportSection
